<!-- @if (data && properties) {
  <app-search [data]="data" [properties]="properties"></app-search>
} -->

@if (data && data.Id && data.Id > 0) {
  <app-search [showSearch]="true" [data]="data"></app-search>
  @if (data.Locations && data.Locations.length > 0) {
    <div class="locations">
      @for (location of data.Locations; track $index) {
        <a [routerLink]="['/' + location.Url]"
          >Hoteller i {{ location.Name }}</a
        >
      }
    </div>
  }
}
